var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClasses},[_c('span',{staticClass:"budget-title"},[_vm._v("\n    "+_vm._s(_vm.header)+"\n  ")]),_vm._v(" "),_c('span',{attrs:{"id":_vm.customId}},[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }